<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      :key="item.label"
      :label="item.label"
      :prop="item.prop"
      v-for="item in tabledataList"
      :label-class-name="item.labelColor ? item.labelColor : ''"
      align="center"
    >
      <el-table-column
        :prop="childrenItem.prop"
        :label="childrenItem.label"
        :min-width="childrenItem.width ? childrenItem.width : '140'"
        fixed
        v-for="(childrenItem, childrenIndex) in item.childrenProps"
        :key="childrenItem.label + childrenIndex"
        :label-class-name="item.labelColor ? item.labelColor : ''"
        align="center"
      >
        <template slot-scope="{ row }">
          <span
            v-if="
              childrenItem.prop != 'skuName' &&
              childrenItem.prop != 'repurchaseSkuName'
            "
            >{{ row[childrenItem.prop] }}</span
          >
          <textOverflowTooltip
            v-else
            :content="row[childrenItem.prop]"
            :lines="1"
          />
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import mixins from "../../../mixins/index.js";
import dayjs from "dayjs";
import Empty from "../../../components/empty.vue";
export default {
  name: "repurchaseCom",
  mixins: [mixins],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    payTimeStart: {
      type: String,
      default: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    },
    payTimeEnd: {
      type: String,
      default: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    },
    reportParams: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Empty,
    textOverflowTooltip: () =>
      import(
        "@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"
      ),
  },
  data() {
    return {
      tableHeadText: "",
    };
  },
  computed: {
    countTable() {
      const tableList = [];
      this.tableData.forEach((item) => {
        if (item.repurchaseList && item.repurchaseList.length > 0) {
          item.repurchaseList.forEach((item2) => {
            tableList.push({
              ...item,
              ...item2,
              classifyId: item.classifyId,
              classifyName: item.classifyName,
            });
          });
        } else {
          tableList.push({
            ...item,
            classifyId: item.classifyId,
            classifyName: item.classifyName,
          });
        }
      });
      return tableList.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (
            key === "index" ||
            key === "skuId" ||
            key === "skuName" ||
            key === "rank" ||
            key === "repurchaseSkuId" ||
            key === "repurchaseSkuName" ||
            key === "classifyId" ||
            key === "classifyName" ||
            key === "repurchaseClassifyName"
          ) {
            newRow[key] = row[key];
            return;
          }
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品spu",
        category: "类目Id",
        sellerCategory: "类目Id",
        itemTag: "标签Id",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
        itemTag: "标签名称",
      };
      return map[this.dataType] || "";
    },
    thirdColumnLabel() {
      const map = {
        sku: "复购skuId",
        spu: "复购商品Id",
        category: "复购类目Id",
        sellerCategory: "复购类目Id",
        itemTag: "复购标签Id",
      };
      return map[this.dataType] || "复购类目Id";
    },
    fourthColumnLabel() {
      const map = {
        sku: "复购商品名称",
        spu: "复购商品名称",
        category: "复购类目名称",
        sellerCategory: "复购类目名称",
        itemTag: "复购标签名称",
      };
      return map[this.dataType] || "复购类目名称";
    },
    // 统计时间范围
    tabledataList() {
      let childrenProps = [];
      if (this.dataType != "itemTag") {
        childrenProps.push({
          prop: "skuId",
          label: this.firstColumnLabel,
          width: "180",
        });
      }
      if (this.dataType == "itemTag") {
        childrenProps.push({
          prop: "classifyName",
          label: "标签分类",
        });
      }
      childrenProps.push({
        prop: "skuName",
        label: this.secondColumnLabel,
      });
      childrenProps.push(
        {
          prop: "buyCount",
          label: "购买人数",
        },
        {
          prop: "buyOrderCount",
          label: "购买单量",
        },
        {
          prop: "buyItemCount",
          label: "购买件数",
        },
        {
          prop: "buyAmount",
          label: "购买金额",
        },
        {
          prop: "rank",
          label: this.prevReportView == 0 ? "复购排名" : "复购率排名",
        }
      );

      if (this.dataType != "itemTag") {
        childrenProps.push({
          prop: "repurchaseSkuId",
          label: this.thirdColumnLabel,
          width: "180",
        });
      }
      if (this.dataType == "itemTag") {
        childrenProps.push({
          prop: "repurchaseClassifyName",
          label: "复购标签分类",
          width: "180",
        });
      }
      childrenProps.push({
        prop: "repurchaseSkuName",
        label: this.fourthColumnLabel,
      });

      childrenProps.push(
        {
          prop: "repurchaseCount",
          label: "复购人数",
        },
        {
          prop: "repurchaseOrderCount",
          label: "复购单量",
        },
        {
          prop: "repurchaseItemCount",
          label: "复购件数",
        },
        {
          prop: "repurchaseAmount",
          label: "复购金额",
        },
        {
          prop: "repurchaseRatio",
          label: "复购率",
        },
        {
          prop: "lossRatio",
          label: "流失率",
        }
      );
      return [
        // 当前
        {
          label: this.tableHeadText,
          childrenProps: childrenProps,
        },
      ];
    },
    prevReportView(){
			return this.reportParams.reportView || 0;
		},
    rebuyTimeStart(){
			return this.reportParams.rebuyTimeStart || dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00";
		},
    rebuyTimeEnd(){
			return this.reportParams.rebuyTimeEnd || dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59";
		},
    timeRangeType(){
			return this.reportParams.timeRangeType || '2';
		},
    rebuyTimeRangeType(){
			return this.reportParams.rebuyTimeRangeType || '2';
		},
  },
  created() {
    this.tableHeadText = this.generateHeadText();
  },
  methods: {
    generateHeadText() {
      return `(付款时间${this.formatDateStr(
        this.payTimeStart,'start',this.timeRangeType
      )}-${this.formatDateStr(
        this.payTimeEnd,'end',this.timeRangeType
      )}，复购时间${this.formatDateStr(
        this.rebuyTimeStart,'start',this.rebuyTimeRangeType
      )}-${this.formatDateStr(this.rebuyTimeEnd,'end',this.rebuyTimeRangeType)})`;
    },
    formatDateStr(dateStr,type,timeType) {
      if (!dateStr) return "";
      const data = new Date(dateStr);
      const y = data.getFullYear();
      const m = String(data.getMonth() + 1).padStart(2, "0");
      const d = String(data.getDate()).padStart(2, "0");
      if(timeType == '4'){
        const hh = String(data.getHours()).padStart(2, "0");
        const mm = String(data.getMinutes()).padStart(2, "0");
        const ss = String(data.getSeconds()).padStart(2, "0");
        return `${y}年${m}月${d}日 ${hh}:${mm}:${ss}`;
      } else if(type == 'start'){
        return `${y}年${m}月${d}日 00:00:00`;
      } else {
        return `${y}年${m}月${d}日 23:59:59`;
      }
    },
    // 表格合并方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const firstColField = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
      // 处理第一行是合计行情况
      if (rowIndex == 0) {
        const firstColProp = firstColField;
        const secondColProp = 'skuName';
        const v1 = row[firstColProp];
        const v2 = row[secondColProp];
        if (v1 === v2 && v1 === '合计') {
          if (column.property === firstColProp) {
            return { rowspan: 1, colspan: 2 };
          }
          if (column.property === secondColProp) {
            return { rowspan: 1, colspan: 0 };
          }
          return { rowspan: 1, colspan: 1 };
        }
      }
      // 按关联率时，不需要合并
      if (this.prevReportView == 1) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 需要合并的字段列表
      const mergeFields = this.dataType != 'itemTag'
                          ? ["skuId", "skuName", "buyCount", "buyOrderCount", "buyItemCount", "buyAmount"]
                          : ["index", "skuId", "skuName", "classifyId", "classifyName", "buyCount", "buyOrderCount", "buyItemCount", "buyAmount"];
      // 获取当前列的prop
      const prop = column.property;
      // 如果不是需要合并的字段，不进行合并
      if (!mergeFields.includes(prop)) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      // 检查第一行是否为合计行，若是则第二行跳过向上合并检查（避免被错误地合并到 rowspan=1 的合计行）
      const firstRow = this.countTable[0] || {};
      const isFirstRowTotal = firstRow[firstColField] === firstRow['skuName'] && firstRow[firstColField] === '合计';
      // 查找相同数据的行范围
      if (rowIndex > 0 && !(isFirstRowTotal && rowIndex == 1)) {
        const prevRow = this.countTable[rowIndex - 1];
        const currentRow = this.countTable[rowIndex];
        // 检查当前行和前一行是否需要合并
        let shouldMerge = true;
        for (const field of mergeFields) {
          if (prevRow[field] !== currentRow[field]) {
            shouldMerge = false;
            break;
          }
        }
        if (shouldMerge) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      // 计算当前相同数据的行数
      let rowspan = 1;
      for (let i = rowIndex + 1; i < this.countTable.length; i++) {
        const nextRow = this.countTable[i];
        let isSame = true;

        for (const field of mergeFields) {
          if (this.countTable[rowIndex][field] !== nextRow[field]) {
            isSame = false;
            break;
          }
        }
        if (isSame) {
          rowspan++;
        } else {
          break;
        }
      }
      return {
        rowspan: rowspan,
        colspan: 1,
      };
    },
  },
};
</script>
